"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMycDebug = exports.default = exports.addDebugAttribute = void 0;
var _uuid = require("./uuid");
var _logger = _interopRequireDefault(require("./logger"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var logger = new _logger.default('utils:debug');
function getName(obj) {
  var _obj$constructor;
  // WARNING: SHOULD not be use on minified code
  // Only for local debug
  if (typeof obj === 'undefined') return 'undefined';
  if (obj === null) return 'null';
  return obj.name || ((_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name);
}
var myc = {};
var addDebugAttribute = (value, name) => {
  var attr = name || getName(value) || (0, _uuid.generate)();
  logger.log('Registering', attr);
  if (!myc) myc = {};
  if (myc.attr) {
    // in case of doublon ?
    myc["".concat(attr, "-").concat((0, _uuid.generate)())] = value;
  } else {
    myc[attr] = value;
  }
  return value;
};
exports.addDebugAttribute = addDebugAttribute;
var getMycDebug = () => myc;
exports.getMycDebug = getMycDebug;
var _default = exports.default = {
  addDebugAttribute,
  getMycDebug
};